module.exports = __webpack_public_path__ + "img/modal4.c879eed9.png";